import EventExperience from "./index.vue";
import Vue from "vue";
import {
  ContainerComputed,
  ContainerData,
  ContainerMethods,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isFetchingEventExperience: true
    };
  },
  computed: {
    eventExperienceId() {
      return Number(this.$route.params["eventExperienceId"]);
    },
    eventExperience() {
      return this.$store.state.domains.eventExperience.eventExperience;
    }
  },

  async mounted() {
    await this.fetchEventExperience(this.eventExperienceId);
  },
  methods: {
    async fetchEventExperience(eventExperienceId, loading = true) {
      try {
        this.isFetchingEventExperience = loading;
        await this.$store.dispatch(
          "domains/eventExperience/getEventExperience",
          {
            eventExperienceId
          }
        );
      } catch (error) {
        throw error;
      } finally {
        this.isFetchingEventExperience = false;
      }
    },
    async createClip(params) {
      try {
        await this.$store.dispatch("domains/clips/createClip", {
          event_detail_id: params.event_detail_id,
          experience_id: params.experience_id
        });
        await this.fetchEventExperience(this.eventExperienceId, false);
      } catch (error) {
        throw error;
      }
    },
    async deleteClip(params) {
      try {
        await this.$store.dispatch("domains/clips/deleteClip", {
          clip_id: params.clip_id
        });
      } catch (error) {
        throw error;
      }
    }
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    this.fetchEventExperience(this.eventExperienceId);
  },
  render(createElement) {
    return createElement(EventExperience, {
      props: {
        partnerId: this.eventExperienceId,
        eventExperience:
          this.eventExperience && this.eventExperience.event_experience,
        company:
          this.eventExperience &&
          this.eventExperience.competitor &&
          this.eventExperience.competitor.company,
        category: this.eventExperience && this.eventExperience.category,
        graduateYear:
          this.eventExperience &&
          this.eventExperience.graduate_year &&
          Number(this.eventExperience.graduate_year.substring(0, 4)),
        experienceReview:
          this.eventExperience && this.eventExperience.experience_review,
        isLoading: this.isFetchingEventExperience
      },
      on: {
        createClip: this.createClip,
        deleteClip: this.deleteClip
      }
    });
  }
});
